import {
    BaseUpdateComponent,
    BaseDataService,
    ModalService,
    NotificationService,
    ErrorHandlerService,
} from 'yt-ng-framework';

import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { EPrijemnicaOpasnaMaterija } from './eprijemnica-opasna-materija';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'yt-eprijemnica-opasna-materija-update',
    templateUrl: './eprijemnica-opasna-materija-update.component.html'
})
export class EPrijemnicaOpasnaMaterijaUpdateComponent
    extends BaseUpdateComponent<EPrijemnicaOpasnaMaterija>
    implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected errorService: ErrorHandlerService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.addValidatorToFc('Naziv', Validators.required, 'required', 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.VALIDATION.REQUIRED');
        this.addValidatorToFc('Vrednost', Validators.required, 'required', 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.VALIDATION.REQUIRED');
        //this.addValidatorToFc('EPrijemnicaID', Validators.required, 'required', 'EOTPREMNICA.ID.REQUIRED');
         
        this.IDProcessed
            .subscribe((value) => {
                if (value){                    
                    this.baseFormGroup.disable();
                    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                }
            })

    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
